export const RenderIf = ({ children, isTrue }) => {
  return isTrue ? children : null;
};
